// admin/src/App.js

import React from "react";
import { HydraAdmin, ResourceGuesser, ListGuesser } from "@api-platform/admin";
import { DatagridBody, Resource } from "react-admin";
import authProvider from './providers/authProviders';
import customRoutes from './routes';
import {createMuiTheme} from '@material-ui/core/styles';
import UtilizationList from './Entity/utilizations';
import WidgetList from './Entity/Widgets/widgetsList';
import WidgetEdit from './Entity/Widgets/widgetsEdit';
import WidgetsCreate from './Entity/Widgets/widgetsCreate';
import Dashboard from './Pages/dashboard';
import LoginPage from './Pages/login';
import layout from './Layout/layout';
import Menu from './Layout/Menu';
import dataProvider from './providers/dataProvider';
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_ID
}
TagManager.initialize(tagManagerArgs)



const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;
//02e15d38da58350758bed97514f9e695





const myTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#395951',
            contrastText: '#fff',
        },
        secondary: {
            main: '#fff',
        },
    },
});


const hasRole = (role) => {
    let permissions =  localStorage.getItem('permissions');
    if(permissions) {
        return permissions.includes(role);
    }
    return false;
};

// @api-platform/admin 2.8.4's ListGuesser passes DatagridBodyWithMercure (a component
// reference) as the `body` prop, but react-admin 3.x's Datagrid expects `body` to be a
// React element and clones it internally — the mismatch produces an element with an
// undefined type at render time (React error #130). Passing an explicit element works
// around the incompatibility.
const FixedListGuesser = (props) => <ListGuesser {...props} body={<DatagridBody />} />;



function App() {
    window.dataLayer.push({
        event: 'pageview'
    });



    return (
        <>

        <HydraAdmin
            dashboard={ Dashboard }
            customRoutes={customRoutes}
            dataProvider={ dataProvider }
            authProvider={ authProvider }
            entrypoint={ entrypoint }
            loginPage={ LoginPage }
            layout ={ layout }
            menu = { Menu }
            theme ={ myTheme }

        >

            <ResourceGuesser name="activities" list={FixedListGuesser} />
            <ResourceGuesser name="authorisations" list={FixedListGuesser} />
            <ResourceGuesser name="classifications" list={FixedListGuesser} />
            <ResourceGuesser name="granularities" list={FixedListGuesser} />
            <ResourceGuesser name="granularity_time_zones" list={FixedListGuesser} />

            <ResourceGuesser name="users" list={FixedListGuesser} />
            <ResourceGuesser name="points" list={FixedListGuesser} />
            <ResourceGuesser name="types" list={FixedListGuesser} />
            <ResourceGuesser name="utilizations" list={ UtilizationList } />
            <Resource name="widgets" list={ WidgetList } edit={WidgetEdit} create={ hasRole('NETANDERS_ADMIN') ? WidgetsCreate : null }  />

        </HydraAdmin>
            </>
    );
}


export default App;